<template>
    <div>
        <div class="tableDiv">
            <v-layout wrap vuetify-grid>
                <v-flex xs12 sm12 md3 sm-side-padding>
                    <v-autocomplete
                        v-model="SelectedFieldDataForm"
                        :items="FieldDataFormOpts"
                        item-text="name"
                        item-value="id"
                        label="Field Data Form"
                        clearable
                        solo
                        :hide-details="true"
                        @change="handleDropdownChange('FieldDataFormId', $event)"
                    />
                </v-flex>

                <v-flex xs12 sm12 md3 sm-side-padding>
                    <v-autocomplete
                        v-model="SelectedTrial"
                        :items="TrialOpts"
                        item-text="name"
                        item-value="id"
                        label="Trial"
                        clearable
                        solo
                        :hide-details="true"
                        @change="handleDropdownChange('TrialId', $event)"
                    />
                </v-flex>
			  
                <v-flex xs12 sm12 md3 sm-side-padding>
                    <v-autocomplete
                        v-model="SelectedProgeny"
                        :items="ProgenyOpts"
                        item-text="name"
                        item-value="id"
                        label="Progeny"
                        clearable
                        solo
                        :hide-details="true"
                        @change="handleDropdownChange('ProgenyId', $event)"
                    />
                </v-flex>

                <v-flex xs12 sm12 md3 sm-side-padding>
                    <v-autocomplete
                        v-model="SelectedPalm"
                        :items="PalmOpts"
                        item-text="name"
                        item-value="id"
                        label="Palm"
                        clearable
                        solo
                        :hide-details="true"
                        @change="handleDropdownChange('PalmId', $event)"
                    />
                </v-flex>
            </v-layout>
            <br>

            <h4>Other Recording</h4>
            <agrinome-table
                :api-mode="true"
                :columns="columns"
                :selection-row.sync="selectionRow"
                :http-options="httpOptions"
                :api-url="apiUrl"
                :append-params="appendParams"
                @handle-edit="handleEdit"
                @handle-delete="handleDelete"	
            />
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            tableId: "#rawOtherRecording",
            FieldDataFormOpts: [],
            TrialOpts: [],
            ProgenyOpts: [],
            PalmOpts: [],

            SelectedFieldDataForm: null,
            SelectedTrial: null,
            SelectedProgeny: null,
            SelectedPalm: null,
				
            TableData: [],
            extensionDataList: [],

            columns: [
                {
                    name: "id",
                    label: "Id",
                    width: "60",
                    sortable: "custom",
                    isDisableEdit: true
                },
                {
                    name: "palmId",
                    label: "Palm Id",
                    width: "100",
                    sortable: "custom"
                },
                {
                    name: "fieldDataForm.name",
                    label: "Field Data Form",
                    minWidth: "160",
                    sortable: "custom",
                    editOpts: [],
                    editOptId: "fieldDataFormId",
                },
                {
                    name: "recordingUser.userName",
                    label: "Recorded By",
                    minWidth: "120",
                    sortable: "custom",
                },
                {
                    name: "creationTime",
                    label: "Recorded At",
                    width: "180",
                    sortable: "custom",
                    formatter (row, col, cell, index) {
                        return moment(cell).local().format("lll");
                    },
                    isDisableEdit: true
                }
            ],
            selectionRow: [],
            apiUrl: "/api/services/app/FieldDataFormPalmRecording/GetAll",
            httpOptions: {
                baseUrl: process.env.ROOT_API,
                headers: {
                    "Authorization": "Bearer " + TokenService.getToken()
                }
            },
            appendParams: {
                FieldDataFormId: null,
                PalmId: null,
                TrialId: null,
                ProgenyId: null,
            },
				
            displayJSON: [
                {
                    "fieldDataForm": {
                        "name": "Integer Test",
                        "customFields": [],
                        "fieldDataTable": null,
                        "fieldDataTableId": null,
                        "lastModificationTime": null,
                        "lastModifierUserId": null,
                        "creationTime": "2019-12-26T07:52:01.9387134Z",
                        "creatorUserId": 2,
                        "id": 6
                    },
                    "fieldDataFormId": 6,
                    "externalGuid": "00000000-0000-0000-0000-000000000000",
                    "experimentRecordingType": null,
                    "experimentRecordingTypeId": null,
                    "palm": {
                        "experiment": null,
                        "experimentId": null,
                        "trial": null,
                        "trialId": 3,
                        "progeny": null,
                        "progenyId": 33,
                        "standardList": [],
                        "palmTCInfo": null,
                        "trialProgenyCalculatedData": null,
                        "code": null,
                        "experimentPalmNumber": null,
                        "trialPalmNumber": "8910",
                        "palmNumber": null,
                        "palmStatus": null,
                        "palmStatusId": null,
                        "fruitType": null,
                        "fruitTypeId": 1,
                        "repNumber": null,
                        "blockNumber": null,
                        "plotNumber": null,
                        "coordinates": null,
                        "palmCalculatedData": null,
                        "qrCode": null,
                        "qrCodeId": null,
                        "statusRemarks": null,
                        "plot": null,
                        "plotId": null,
                        "numberofRecordingCollected": null,
                        "numberOfSamplingCollected": null,
                        "lastModificationTime": "2019-09-17T09:29:52.5678142Z",
                        "lastModifierUserId": null,
                        "creationTime": "2019-09-17T09:29:52.5559397Z",
                        "creatorUserId": null,
                        "id": 1492
                    },
                    "palmId": 1492,
                    "extensionData": "[{\"Name\":\"Weight\",\"Value\":\"20\",\"ValueObject\":null,\"CustomFieldId\":144,\"Errors\":[]}]",
                    "creatorUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "extensionDataList": [
                        {
                            "name": "Weight",
                            "value": "20",
                            "valueObject": null,
                            "customFieldId": 144,
                            "errors": []
                        }
                    ],
                    "recordingNumber": 1,
                    "recordingDate": "2019-12-30T04:34:10Z",
                    "syncTime": "2019-12-30T04:34:12.9970153Z",
                    "syncUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "syncUserId": 2,
                    "recordingUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "recordingUserId": 2,
                    "lastModificationTime": null,
                    "lastModifierUserId": null,
                    "creationTime": "2019-12-30T04:34:12.9652055Z",
                    "creatorUserId": 2,
                    "id": 6
                },
                {
                    "fieldDataForm": {
                        "name": "Requirement Test",
                        "customFields": [],
                        "fieldDataTable": null,
                        "fieldDataTableId": null,
                        "lastModificationTime": null,
                        "lastModifierUserId": null,
                        "creationTime": "2019-12-26T07:24:58.637142Z",
                        "creatorUserId": 2,
                        "id": 5
                    },
                    "fieldDataFormId": 5,
                    "externalGuid": "00000000-0000-0000-0000-000000000000",
                    "experimentRecordingType": null,
                    "experimentRecordingTypeId": null,
                    "palm": {
                        "experiment": null,
                        "experimentId": null,
                        "trial": null,
                        "trialId": 12,
                        "progeny": null,
                        "progenyId": 58,
                        "standardList": [],
                        "palmTCInfo": null,
                        "trialProgenyCalculatedData": null,
                        "code": null,
                        "experimentPalmNumber": null,
                        "trialPalmNumber": "1",
                        "palmNumber": null,
                        "palmStatus": null,
                        "palmStatusId": null,
                        "fruitType": null,
                        "fruitTypeId": 1,
                        "repNumber": null,
                        "blockNumber": null,
                        "plotNumber": null,
                        "coordinates": null,
                        "palmCalculatedData": null,
                        "qrCode": null,
                        "qrCodeId": null,
                        "statusRemarks": null,
                        "plot": null,
                        "plotId": null,
                        "numberofRecordingCollected": null,
                        "numberOfSamplingCollected": null,
                        "lastModificationTime": "2019-09-17T09:30:10.8158321Z",
                        "lastModifierUserId": null,
                        "creationTime": "2019-09-17T09:30:10.8062703Z",
                        "creatorUserId": null,
                        "id": 1804
                    },
                    "palmId": 1804,
                    "extensionData": "[{\"Name\":\"Number 50\",\"Value\":\"77\",\"ValueObject\":null,\"CustomFieldId\":142,\"Errors\":[]},{\"Name\":\"Required If 50\",\"Value\":\"32\",\"ValueObject\":null,\"CustomFieldId\":143,\"Errors\":[]}]",
                    "creatorUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "extensionDataList": [
                        {
                            "name": "Number 50",
                            "value": "77",
                            "valueObject": null,
                            "customFieldId": 142,
                            "errors": []
                        },
                        {
                            "name": "Required If 50",
                            "value": "32",
                            "valueObject": null,
                            "customFieldId": 143,
                            "errors": []
                        }
                    ],
                    "recordingNumber": 1,
                    "recordingDate": "2019-12-31T07:25:21Z",
                    "syncTime": "2019-12-31T07:25:22.5065394Z",
                    "syncUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "syncUserId": 2,
                    "recordingUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "recordingUserId": 2,
                    "lastModificationTime": null,
                    "lastModifierUserId": null,
                    "creationTime": "2019-12-31T07:25:22.479869Z",
                    "creatorUserId": 2,
                    "id": 7
                },
                {
                    "fieldDataForm": {
                        "name": "Requirement Test",
                        "customFields": [],
                        "fieldDataTable": null,
                        "fieldDataTableId": null,
                        "lastModificationTime": null,
                        "lastModifierUserId": null,
                        "creationTime": "2019-12-26T07:24:58.637142Z",
                        "creatorUserId": 2,
                        "id": 5
                    },
                    "fieldDataFormId": 5,
                    "externalGuid": "00000000-0000-0000-0000-000000000000",
                    "experimentRecordingType": null,
                    "experimentRecordingTypeId": null,
                    "palm": {
                        "experiment": null,
                        "experimentId": null,
                        "trial": null,
                        "trialId": 12,
                        "progeny": null,
                        "progenyId": 58,
                        "standardList": [],
                        "palmTCInfo": null,
                        "trialProgenyCalculatedData": null,
                        "code": null,
                        "experimentPalmNumber": null,
                        "trialPalmNumber": "1",
                        "palmNumber": null,
                        "palmStatus": null,
                        "palmStatusId": null,
                        "fruitType": null,
                        "fruitTypeId": 1,
                        "repNumber": null,
                        "blockNumber": null,
                        "plotNumber": null,
                        "coordinates": null,
                        "palmCalculatedData": null,
                        "qrCode": null,
                        "qrCodeId": null,
                        "statusRemarks": null,
                        "plot": null,
                        "plotId": null,
                        "numberofRecordingCollected": null,
                        "numberOfSamplingCollected": null,
                        "lastModificationTime": "2019-09-17T09:30:10.8158321Z",
                        "lastModifierUserId": null,
                        "creationTime": "2019-09-17T09:30:10.8062703Z",
                        "creatorUserId": null,
                        "id": 1804
                    },
                    "palmId": 1804,
                    "extensionData": "[{\"Name\":\"Number 50\",\"Value\":\"88\",\"ValueObject\":null,\"CustomFieldId\":142,\"Errors\":[]},{\"Name\":\"Required If 50\",\"Value\":\"88\",\"ValueObject\":null,\"CustomFieldId\":143,\"Errors\":[]}]",
                    "creatorUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "extensionDataList": [
                        {
                            "name": "Number 50",
                            "value": "88",
                            "valueObject": null,
                            "customFieldId": 142,
                            "errors": []
                        },
                        {
                            "name": "Required If 50",
                            "value": "88",
                            "valueObject": null,
                            "customFieldId": 143,
                            "errors": []
                        }
                    ],
                    "recordingNumber": 2,
                    "recordingDate": "2019-12-31T07:25:57Z",
                    "syncTime": "2019-12-31T07:25:54.7906112Z",
                    "syncUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "syncUserId": 2,
                    "recordingUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "recordingUserId": 2,
                    "lastModificationTime": null,
                    "lastModifierUserId": null,
                    "creationTime": "2019-12-31T07:25:54.7890617Z",
                    "creatorUserId": 2,
                    "id": 8
                },
                {
                    "fieldDataForm": {
                        "name": "Integer Test",
                        "customFields": [],
                        "fieldDataTable": null,
                        "fieldDataTableId": null,
                        "lastModificationTime": null,
                        "lastModifierUserId": null,
                        "creationTime": "2019-12-26T07:52:01.9387134Z",
                        "creatorUserId": 2,
                        "id": 6
                    },
                    "fieldDataFormId": 6,
                    "externalGuid": "00000000-0000-0000-0000-000000000000",
                    "experimentRecordingType": null,
                    "experimentRecordingTypeId": null,
                    "palm": {
                        "experiment": null,
                        "experimentId": null,
                        "trial": null,
                        "trialId": 3,
                        "progeny": null,
                        "progenyId": 33,
                        "standardList": [],
                        "palmTCInfo": null,
                        "trialProgenyCalculatedData": null,
                        "code": null,
                        "experimentPalmNumber": null,
                        "trialPalmNumber": "8902",
                        "palmNumber": null,
                        "palmStatus": null,
                        "palmStatusId": null,
                        "fruitType": null,
                        "fruitTypeId": 1,
                        "repNumber": null,
                        "blockNumber": null,
                        "plotNumber": null,
                        "coordinates": null,
                        "palmCalculatedData": null,
                        "qrCode": null,
                        "qrCodeId": null,
                        "statusRemarks": null,
                        "plot": null,
                        "plotId": null,
                        "numberofRecordingCollected": null,
                        "numberOfSamplingCollected": null,
                        "lastModificationTime": "2019-09-17T09:29:52.2649545Z",
                        "lastModifierUserId": null,
                        "creationTime": "2019-09-17T09:29:52.2550652Z",
                        "creatorUserId": null,
                        "id": 1484
                    },
                    "palmId": 1484,
                    "extensionData": "[{\"Name\":\"Weight\",\"Value\":\"20\",\"ValueObject\":null,\"CustomFieldId\":144,\"Errors\":[]}]",
                    "creatorUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "extensionDataList": [
                        {
                            "name": "Weight",
                            "value": "20",
                            "valueObject": null,
                            "customFieldId": 144,
                            "errors": []
                        }
                    ],
                    "recordingNumber": 1,
                    "recordingDate": "2020-01-03T04:14:46Z",
                    "syncTime": "2020-01-03T04:14:46.7673957Z",
                    "syncUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "syncUserId": 2,
                    "recordingUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "recordingUserId": 2,
                    "lastModificationTime": null,
                    "lastModifierUserId": null,
                    "creationTime": "2020-01-03T04:14:46.749296Z",
                    "creatorUserId": 2,
                    "id": 9
                },
                {
                    "fieldDataForm": {
                        "name": "Multiple Group",
                        "customFields": [],
                        "fieldDataTable": null,
                        "fieldDataTableId": null,
                        "lastModificationTime": null,
                        "lastModifierUserId": null,
                        "creationTime": "2019-12-27T09:01:23.1772092Z",
                        "creatorUserId": 2,
                        "id": 14
                    },
                    "fieldDataFormId": 14,
                    "externalGuid": "00000000-0000-0000-0000-000000000000",
                    "experimentRecordingType": null,
                    "experimentRecordingTypeId": null,
                    "palm": {
                        "experiment": null,
                        "experimentId": null,
                        "trial": null,
                        "trialId": 4,
                        "progeny": null,
                        "progenyId": 46,
                        "standardList": [],
                        "palmTCInfo": null,
                        "trialProgenyCalculatedData": null,
                        "code": null,
                        "experimentPalmNumber": null,
                        "trialPalmNumber": "639",
                        "palmNumber": null,
                        "palmStatus": null,
                        "palmStatusId": null,
                        "fruitType": null,
                        "fruitTypeId": 1,
                        "repNumber": null,
                        "blockNumber": null,
                        "plotNumber": null,
                        "coordinates": null,
                        "palmCalculatedData": null,
                        "qrCode": null,
                        "qrCodeId": null,
                        "statusRemarks": null,
                        "plot": null,
                        "plotId": null,
                        "numberofRecordingCollected": null,
                        "numberOfSamplingCollected": null,
                        "lastModificationTime": "2019-09-17T09:30:02.2523384Z",
                        "lastModifierUserId": null,
                        "creationTime": "2019-09-17T09:30:02.2428758Z",
                        "creatorUserId": null,
                        "id": 1679
                    },
                    "palmId": 1679,
                    "extensionData": "[{\"Name\":\"Section 1\",\"Value\":null,\"ValueObject\":null,\"CustomFieldId\":169,\"Errors\":[]}]",
                    "creatorUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "extensionDataList": [
                        {
                            "name": "Section 1",
                            "value": null,
                            "valueObject": null,
                            "customFieldId": 169,
                            "errors": []
                        }
                    ],
                    "recordingNumber": 1,
                    "recordingDate": "2020-01-03T07:12:51Z",
                    "syncTime": "2020-01-03T07:12:51.1983696Z",
                    "syncUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "syncUserId": 2,
                    "recordingUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "recordingUserId": 2,
                    "lastModificationTime": null,
                    "lastModifierUserId": null,
                    "creationTime": "2020-01-03T07:12:51.1956766Z",
                    "creatorUserId": 2,
                    "id": 10
                },
                {
                    "fieldDataForm": {
                        "name": "Multiple Sections",
                        "customFields": [],
                        "fieldDataTable": null,
                        "fieldDataTableId": null,
                        "lastModificationTime": null,
                        "lastModifierUserId": null,
                        "creationTime": "2020-01-03T02:42:36.4614448Z",
                        "creatorUserId": 2,
                        "id": 16
                    },
                    "fieldDataFormId": 16,
                    "externalGuid": "00000000-0000-0000-0000-000000000000",
                    "experimentRecordingType": null,
                    "experimentRecordingTypeId": null,
                    "palm": {
                        "experiment": null,
                        "experimentId": null,
                        "trial": null,
                        "trialId": 4,
                        "progeny": null,
                        "progenyId": 46,
                        "standardList": [],
                        "palmTCInfo": null,
                        "trialProgenyCalculatedData": null,
                        "code": null,
                        "experimentPalmNumber": null,
                        "trialPalmNumber": "639",
                        "palmNumber": null,
                        "palmStatus": null,
                        "palmStatusId": null,
                        "fruitType": null,
                        "fruitTypeId": 1,
                        "repNumber": null,
                        "blockNumber": null,
                        "plotNumber": null,
                        "coordinates": null,
                        "palmCalculatedData": null,
                        "qrCode": null,
                        "qrCodeId": null,
                        "statusRemarks": null,
                        "plot": null,
                        "plotId": null,
                        "numberofRecordingCollected": null,
                        "numberOfSamplingCollected": null,
                        "lastModificationTime": "2019-09-17T09:30:02.2523384Z",
                        "lastModifierUserId": null,
                        "creationTime": "2019-09-17T09:30:02.2428758Z",
                        "creatorUserId": null,
                        "id": 1679
                    },
                    "palmId": 1679,
                    "extensionData": "[{\"Name\":\"Section 1\",\"Value\":null,\"ValueObject\":null,\"CustomFieldId\":175,\"Errors\":[]},{\"Name\":\"Section_2\",\"Value\":null,\"ValueObject\":null,\"CustomFieldId\":176,\"Errors\":[]}]",
                    "creatorUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "extensionDataList": [
                        {
                            "name": "Section 1",
                            "value": null,
                            "valueObject": null,
                            "customFieldId": 175,
                            "errors": []
                        },
                        {
                            "name": "Section_2",
                            "value": null,
                            "valueObject": null,
                            "customFieldId": 176,
                            "errors": []
                        }
                    ],
                    "recordingNumber": 1,
                    "recordingDate": "2020-01-03T07:13:08Z",
                    "syncTime": "2020-01-03T07:13:08.0108346Z",
                    "syncUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "syncUserId": 2,
                    "recordingUser": {
                        "userName": "superadmin",
                        "name": "superadmin",
                        "surname": "superadmin",
                        "emailAddress": "superadmin@codongenomics.com",
                        "isActive": true,
                        "fullName": "superadmin superadmin",
                        "lastLoginTime": "2020-01-13T08:44:23.6083041Z",
                        "creationTime": "2019-09-17T09:10:30.8678351Z",
                        "roleNames": null,
                        "department": null,
                        "departmentId": null,
                        "id": 2
                    },
                    "recordingUserId": 2,
                    "lastModificationTime": null,
                    "lastModifierUserId": null,
                    "creationTime": "2020-01-03T07:13:08.0092983Z",
                    "creatorUserId": 2,
                    "id": 11
                }
            ]
        };
    },
    mounted() {
        this.getAllFieldDataForm();
        this.getAllTrial();
        this.getAllProgeny();
        this.getAllPalm();
        // this.getAllFieldDataFormPalmRecording();
        const tHeader = this.columns.map(item => item.label);
        const filterVal = this.columns.map(item => item.name);
        const data = this.formatJson(filterVal, this.displayJSON);
    },
    methods: {
        handleDropdownChange(prop, e) {
            this.appendParams[prop] = e;
        },
        checkIsSameExtension(data, dataCustomFieldId, customFieldId) {
            if (dataCustomFieldId === customFieldId) {
                return data.value;
            }
            else return "-";
        },
        getAllFieldDataFormPalmRecording() {
            var self = this;
            axios({
                method: "GET",
                url: "FieldDataFormPalmRecording/GetAll",
                params: {
                    FieldDataFormId: this.SelectedFieldDataForm,
                    PalmId: this.SelectedPalm,
                    TrialId: this.SelectedTrial,
                    ProgenyId: this.SelectedProgeny
                }
            })
                .then(function (response) {
                    self.TableData = response.data.result.items;
                    self.extensionDataList = response.data.result.items[0].extensionDataList;
                });
        },
        getAllFieldDataForm() {
            var self = this;
            axios({
                method: "GET",
                url: "FieldDataForm/GetAllUnlinkedForDropdown",
            })
                .then(function (response) {
                    self.columns[2].editOpts = response.data.result;
                    self.FieldDataFormOpts = response.data.result;
                });
        },
        getAllTrial() {
            var self = this;
            axios({
                method: "GET",
                url: "Trial/GetAllForDropdown",
            })
                .then(function (response) {
                    self.TrialOpts = response.data.result;
                });
        },
        getAllProgeny() {
            var self = this;
            axios({
                method: "GET",
                url: "Progeny/GetAllForDropdown",
            })
                .then(function (response) {
                    self.ProgenyOpts = response.data.result;
                });
        },
        getAllPalm() {
            var self = this;
            axios({
                method: "GET",
                url: "Palm/GetAllTrialPalmForDropdown",
            })
                .then(function (response) {
                    self.PalmOpts = response.data.result;
                });
        },
        handleEdit(index, row) {
            console.log(index, row);
        },
        handleDelete(index, row) {
            console.log(index, row);
        },
        formatJson(filterVal, jsonData) {
            var data = jsonData.map(v => filterVal.map(j => {
                if (j === "createdAt") {
                    return this.formatCreationTime(v[j]);
                } else {
                    if (j.includes(".")) {
                        let splits = j.split(".");
                        let tempObj = v[splits[0]];
                        return tempObj[splits[1]];
                    }
                    return v[j];
                }
            }));
        },
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Palm/PalmRawData/RawOtherRecording.vue